import { Intent } from "@blueprintjs/core/lib/esm/common";
import { Icon } from "@blueprintjs/core/lib/esm/components/icon/icon";
import { MenuItem } from "@blueprintjs/core/lib/esm/components/menu/menuItem";
import { Spinner } from "@blueprintjs/core/lib/esm/components/spinner/spinner";
import autobind from "autobind-decorator";
import CountResult from "common/entities/CountResult";
import { FlexJustify } from "common/fragments/Flex";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockView } from "common/views/block/BlockView.view";
import { ButtonView } from "common/views/button/Button.view";
import { DropdownSelectView } from "common/views/dropdownSelect/DropdownSelect.view";
import PagingView from "common/views/paging/Paging.view";
import DataTable from "common/views/table/DataTable";
import Query from "core/api/QueryComponent";
import Label from "core/components/label/Label";
import XHRResolverService from "core/service/resolver/impl/XHRResolver.service";
import { clamp } from "core/util/MathUtils";
import ServiceRegistry from "core/util/ServiceRegistry";
import { ForumToaster } from "panels/forum/forumActions";
import React from "react";
import { Field } from "typegraph";
import { Enrollment } from "./entities/Enrollment";
import * as columns from "./fragments/EnrollmentsListFragments";
import { FloatRight, NewPostDiv, SearchBox } from "./TestAssignmentList.panel";
import {default as Autocomplete} from "react-autocomplete";
import './Autocomplete.css'
import styled from "styled-components";
import { iDef } from "core/util/TypeUtils";
import { User } from "./entities/Institution";


const Header = styled.div`	
	padding-bottom: 15px;
    display:flex;
    justify-content: space-around;
    @media(max-width: 768px) {
        flex-direction: column;
        display: flex;
        flex-wrap: wrap;
        min-width: 100%;
	}
`;

const EmptyDiv = styled.div`	
	padding-bottom: 15px;
    @media(max-width: 768px) {
        width: -webkit-fill-available !important;
    }
`;

const RightDiv = styled.div`	
    @media(max-width: 768px) {
        width: -webkit-fill-available;
	}
`;


interface IEnrollmentsComponentState{
    pageSize?:number;
	pageNumber?:number;
    searchFilter?:string;
    userQuery?:string;
    userId?:number;
    usersList?:any;
    enrollRefreshCount?:number;
}

interface IEnrollmentsComponentProps{
    assignmentId:number,
    status?:number
}

class EnrollmentsQuery {
	@Field({
		entity: Enrollment,
		params: (params) => ({params}),
		aliasFor: 'getEnrollments'
	})
	public entities: null | Enrollment[];

	@Field({
		entity: CountResult,
		aliasFor: "getEnrollmentsCount",
		params: (params) => ({params}),
	})
	public count: CountResult;
}

export class EnrollmentsComponent extends React.PureComponent<IEnrollmentsComponentProps,IEnrollmentsComponentState> {

    public refetch:()=> void;

    constructor(props){
        super(props);

        this.state = {
            pageNumber:0,
            pageSize:10,
            searchFilter:"",
            userQuery:"",
            userId:0,
            usersList:[],
            enrollRefreshCount:this.getRandom()
        }

    }

    private refresh() {
        this.setState({enrollRefreshCount:this.getRandom()});
    }

    private getRandom() {
		let min = Math.ceil(1);
		let max = Math.floor(10000000);
		let ref =  Math.floor(Math.random() * (max - min + 1)) + min;
		return ref;
	}

    private setPageSize = (pageSize: number) =>
		this.setState({
			pageSize:pageSize,
			pageNumber:0
		});

	private setPageNumber = (pageNumber: number) =>
		this.setState({
			pageNumber:pageNumber
		});

    @autobind
    public onChangeSearchTerm(event) {
        const searchTerm = event.target.value;
        this.setState({ searchFilter: searchTerm });
    }

    @autobind
    public clear() {
		this.setState({searchFilter: ""});
	}

    enrollAll = () => {
		const resolver = ServiceRegistry.get(XHRResolverService);
		let query:string = "mutation { enrollAll(params: { ";
		query = query + "id: "+this.props.assignmentId+ " }) { entityId } } ";
        const req = [];
        const que = resolver.execute(query).then(req => {
            
            let reqData= JSON.parse(req);
            let data= reqData.data;
            if(reqData.errors){
                let msg = reqData.errors[0].message.split(':')[1];
                console.log(msg);
                ForumToaster.show({
                    intent: Intent.DANGER,
                    message: "Error occurred while enrolling users!!"
                });
            } else if(data['testAssignmentPublish']){
                ForumToaster.show({
                    intent: Intent.SUCCESS,
                    message: "All users enrolled successfully!!"
                });
            }
        }).catch(err => {
            console.log(err);
        });

        req.push(que);
        Promise.all(req)
            .then((value) => {
                this.refresh();
            })
        .catch((reason) => {
            console.log(reason);
            ForumToaster.show({
                intent: Intent.DANGER,
                message: "An error occurred while enrolling users!!"
            });
        });
	}

    enrollNow = () => {
		const resolver = ServiceRegistry.get(XHRResolverService);
		let query:string = "mutation { assignmentUserCreate(params: { ";
		query = query + "id: "+this.state.userId+ ", assignmentId: "+ this.props.assignmentId +" }) { entityId } } ";
        const req = [];
        const que = resolver.execute(query).then(req => {
            
            let reqData= JSON.parse(req);
            let data= reqData.data;
            if(reqData.errors){
                let msg = reqData.errors[0].message.split(':')[1];
                console.log(msg);
                ForumToaster.show({
                    intent: Intent.DANGER,
                    message: "Error occurred while enrolling user!!"
                });
            } else if(data['assignmentUserCreate']){
                ForumToaster.show({
                    intent: Intent.SUCCESS,
                    message: "Selected user enrolled successfully!!"
                });
                this.refetch();
            }
        }).catch(err => {
            console.log(err);
        });

        req.push(que);
        Promise.all(req)
            .then((value) => {
                this.refresh();
            })
        .catch((reason) => {
            console.log(reason);
            ForumToaster.show({
                intent: Intent.DANGER,
                message: "An error occurred while enrolling user!!"
            });
        });
	}

    private async getUsers() {
		if (iDef(this.props.assignmentId)) {
			const res : any = await ServiceRegistry.getQueryService().findMany(User, {id:this.props.assignmentId});
			let data = res && res.data && res.data.entities || [];
			this.setState({
				usersList:data
			  })
		}
	}

    public async componentDidMount() {
        //this.refresh();
		this.getUsers();
	}

    public render() {

        const params = {
			pageSize: this.state.pageSize,
			pageNumber: this.state.pageNumber,
			id:this.props.assignmentId,
            query:this.state.searchFilter,
            refreshCount:this.state.enrollRefreshCount
		};

        let display = (iDef(this.props.status) && this.props.status !== 2) ? "block" : "none";


        return (
            <React.Fragment>
                <Header>
                    <EmptyDiv>
                        <SearchBox
                            placeholder="Search"
                            value={this.state.searchFilter}
                            onChange={this.onChangeSearchTerm}
                        />
                        {this.state.searchFilter && (
                            <ButtonView onClick={this.clear} viewKey="clear">
                                <Icon icon="cross" />
                            </ButtonView>
                        )}
                    </EmptyDiv>
                    
                    <EmptyDiv className="autocomplete-wrapper" style={{display:display}}>                    
                        <Autocomplete
                        
                            value={this.state.userQuery}
                            items={this.state.usersList}
                            getItemValue={item => item.name}
                            shouldItemRender={(item, value) => item.name.toLowerCase()
                                .indexOf(value.toLowerCase()) > -1}
                            renderMenu={item => (
                            <div className="dropdown">
                                {item}
                            </div>
                            )}
                            renderItem={(item, isHighlighted) =>
                                <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                {item.name}
                                </div>
                            }
                            onChange={(event, val) => {
                                this.setState({ userQuery : val })
                                if (val === ""){
                                    this.setState({ userId : 0 })
                                }
                            }}
                            onSelect={(val,item) => this.setState({ userQuery : val, userId : Number.parseInt(item.id) })}
                        
                        />
                    </EmptyDiv>

                    <EmptyDiv style={{display:display}}>
                        <ButtonView viewKey="enroll.button" onClick={this.enrollNow}>
                            <Label k="enroll.button.label" v="Enroll" />
                        </ButtonView>
                    </EmptyDiv>
                    
                    <RightDiv style={{display:display}}>
                        <ButtonView viewKey="enroll.all" onClick={this.enrollAll}>
                            <Label k="enroll.all.label" v="Enroll All" />
                        </ButtonView>
                    </RightDiv>
                </Header>
                <Query.Root entity={EnrollmentsQuery} args={params}>
			        {({loading, data}) => {

                        let total = 0;
                        let start = 0;
                        let end = 0;

                        if (loading){
                            return <Spinner size={Spinner.SIZE_SMALL}/>
                        }
                    

                        if(!loading && (data == null || data.entities == null || data.entities.length === 0)) {
                            return (
                                <NonIdealState
                                    title={"No Data"}
                                    description={""}
                                />
                            );
                        }

                        total = data.count.count;
                        start = 1 + params.pageSize * params.pageNumber;
                        end = clamp(start, total, start + params.pageSize - 1);

                        const lst = data && data.entities || null;
                        const cols = Object.entries(columns).map(([k, v]) => v);

                        return (
                            <React.Fragment>
                                <NewPostDiv>
                                    <FloatRight>
                                        <BlockView viewKey="paging.info">
                                            <Label
                                                k="paging.results.count"
                                                v="${start} - ${end} of ${total} Results"
                                                args={{ start, end, total }}
                                            />
                                        </BlockView>
                                    </FloatRight>
                                </NewPostDiv>
                                <DataTable
                                    viewKeyPrefix="results"
                                    data={lst}
                                    params={params}
                                    entity={Enrollment}
                                    getId={(enrollment) => enrollment.id}
                                    columns={Object.values(cols)}
                                />
                                <BlockView viewKey="bottom">
                                    <FlexJustify>
                                        <div>
                                            <PagingView
                                                viewKey="paging"
                                                pageSize={params["pageSize"]}
                                                pageNumber={params["pageNumber"]}
                                                total={total}
                                                setPageNumber={this.setPageNumber}
                                            />
                                        </div>
                                        <DropdownSelectView
                                            viewKey="pageSize"
                                            onChange={this.setPageSize}
                                            items={[10, 20]}
                                            itemRenderer={(
                                                size: number,
                                                { handleSelect }
                                            ) => {
                                                return (
                                                    <MenuItem
                                                        key={size}
                                                        text={
                                                            <Label
                                                                k="pageSize"
                                                                v="Show ${size}"
                                                                args={{ size }}
                                                            />
                                                        }
                                                        onClick={handleSelect}
                                                    />
                                                );
                                            }}
                                        >
                                            <Label
                                                k="pageSize"
                                                v="Show ${size}"
                                                args={{ size: this.state.pageSize }}
                                            />
                                        </DropdownSelectView>
                                    </FlexJustify>
                                </BlockView>
                            </React.Fragment>
                        );
                    }}
                </Query.Root>
            </React.Fragment>
        )

    }

}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/EnrollmentsComponent.tsx